import get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function DragAndDrop(props) {
  const { children, onDrop, className } = props;

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const file = get(e, 'nativeEvent.dataTransfer.files[0]');
    onDrop(file);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div
      className={cn('drag-and-drop', className)}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}>
      {children}
    </div>
  );
}

DragAndDrop.propTypes = {
  onDrop: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default DragAndDrop;
